import { type MetaFunction } from '@remix-run/node'
import CTA from '#app/components/cta'
import Features from '#app/components/features'
import Hero from '#app/components/hero'
import Pricing from '#app/components/pricing'

export const meta: MetaFunction = () => [
	{ title: 'Question API Vendor Portal' },
]

export default function Index() {
	return (
		<main className="font-poppins h-full">
			<Hero />
			<Features />
			<Pricing />
			<CTA />
		</main>
	)
}
